import classNames from 'classnames'
import NextImage from 'next/image'

import type { StaticImport } from 'next/dist/shared/lib/get-img-props'

export interface ImageProps {
  alt: string
  src: string
  title?: string
  priority?: boolean
  /**
   * Height of the image in pixels.
   * @deprecated Do not use this prop as it will break aspect ratio. Will be removed in the future.
   */
  height?: number
}

export const Image: React.FC<ImageProps> = async ({
  alt,
  src,
  title,
  priority,
  height,
}) => {
  let realSrc: string | StaticImport
  const localHeight = typeof height === 'number' ? height : 0
  try {
    // Need to do this to avoid `Warning: Only plain objects can be passed to Client Components from Server Components`
    realSrc = JSON.parse(
      JSON.stringify(await import(`@shared/content/src${src}?url`)),
    ) as StaticImport
  } catch {
    realSrc = src
  }

  return (
    <div className="mx-auto pb-2 pt-6">
      <div className="w-full border-neutral-subtle">
        <NextImage
          alt={alt}
          className={classNames('mx-auto', {
            'h-auto': localHeight === 0,
          })}
          height={height}
          priority={priority}
          sizes="100vw"
          src={realSrc}
          style={localHeight !== 0 ? { height: localHeight } : {}}
          width={0}
        />
      </div>
      {title && (
        <span className="mt-4 block w-full text-center text-xs uppercase text-neutral-subtle font-circular-bold">
          {title}
        </span>
      )}
    </div>
  )
}
